import { AuthenticationAPI, AuthenticationLegacyAPI } from '../../helpers/APIS/CommonApisSchema';
import { getAuthenticationAPIURL, getAuthenticationLegacyAPIURL } from '../../helpers/CustomApiUrls/CommonApiUrl';
import { callAPIAction } from '../../Store/callAPI/actions';
import { addLinkParamsToStore } from '../../Store/commonStore/actions';

export const handleDobSubmitNew = (linkParams, selectedDate) => {
    linkParams?.environment?.includes('xp')
        ? callAPIAction(AuthenticationAPI, getAuthenticationAPIURL(linkParams?.uniquelink, linkParams?.uniquekey, selectedDate))
        : callAPIAction(AuthenticationLegacyAPI, getAuthenticationLegacyAPIURL(linkParams?.uniquelink, selectedDate));
};

export const getTenantFromHost = (hostName, path) => {
    // List your known tenants here
    const urlWithTenant = process.env.REACT_APP_IS_PROD ? hostName?.toLowerCase() : path;
    const tenants = ['uhc', 'tufts', 'ggh', 'iehp', 'aetna', 'uchwa', 'hpsj'];
    const tenant = tenants?.find((tnt) => urlWithTenant?.includes(tnt));
    return tenant || 'ggh';
};

export const getURLParamas = (Navigate) => {
    const urlPath = window.location.pathname;

    const tenant = getTenantFromHost(window.location.hostname, window.location.pathname);
    let [lang, uniquelink, uniquekey, pageName, modeId] = [];
    let environment = '';
    let xpLang = '';

    if (urlPath.includes('xp')) {
        environment = 'xp';
        const ids = urlPath.split('/authorize/xp/')[1];
        const idslength = ids?.split('/')?.length;

        if (idslength > 2) {
            [lang, uniquelink, uniquekey, pageName, modeId] = ids && ids.length > 0 ? ids.split('/') : [];
            const urlLang = ['en', 'es', 'pt', 'zh'];
            // Validate the language
            if (lang && !urlLang.includes(lang)) {
                return <Navigate to={{ pathname: '/authorize', state: { from: urlPath } }} />;
            }

            xpLang = lang;
        } else {
            [uniquelink, uniquekey] = ids && ids.length > 0 ? ids.split('/') : [];
            lang = 'en';
        }
    } else {
        environment = 'legacy';
        const ids = urlPath.split('/authorize/')[1];
        uniquelink = ids;
        lang = 'en';
        xpLang = 'en';
    }

    addLinkParamsToStore({ lang, uniquelink, uniquekey, environment, xpLang, pageName, modeId: +modeId, tenant });
};

export const getAuthPageContentByLang = (linkParams) => {
    const lang = linkParams?.lang?.toUpperCase() || 'EN';
    if (linkParams?.pageName === 'assessments') {
        return (
            <h6 className="text-justify">
                {lang === 'ES' ? (
                    <p>
                        Para acceder a este formulario, por favor ingrese su fecha de nacimiento en el formato MMDDYYYY (por ejemplo,
                        05311990).
                    </p>
                ) : (
                    <p>
                        To access this form, please enter your date of birth as <span className="font-weight-bold">MMDDYYYY</span>.
                    </p>
                )}
            </h6>
        );
    } else {
        return (
            <h6 className="text-justify">
                {lang === 'ES' ? (
                    <p>
                        GroundGame.Health ayuda a las personas a encontrar programas y servicios para mejorar su salud y bienestar. Hemos
                        creado un plan de apoyo personalizado que identifica en qué áreas podemos ayudarle y brindarle recursos útiles cerca
                        de usted. Para acceder a su plan, ingrese su fecha de nacimiento en el formato MMDDYYYY (por ejemplo, 05311990).
                    </p>
                ) : (
                    <p>
                        To access your care plan, please enter your date of birth as <span className="font-weight-bold">MMDDYYYY</span>.
                    </p>
                )}
            </h6>
        );
    }
};
